import React, { useEffect } from 'react';

const ResellerDashboard = () => {
  useEffect(() => {
    window.location.href = '/reseller-dashboard.html';
  }, []);

  return (
    <div style={{ padding: '40px', textAlign: 'center' }}>
      <p>Redirecting to Reseller Dashboard...</p>
    </div>
  );
};

export default ResellerDashboard;
